import React from 'react'
import Modal from './../index'
import StarRating from './components/ModalRating'
import './modalBooks.css'
import formatCurrencyToBr from 'format-currency-to-br'
import favoriteSeal from '../../../static/images/favorite.png'

const ModalItem = ({ item, handleCloseModal }) => {
  const {book} = item
  const name = book.name ? book.name : item.name

  const renderAuthors = (authors) => {
    if (authors && authors.length > 0) {
      return (
        <div className='modal-book-detail__authors'>
          <p><strong>Autores:</strong></p>
          <ul className='modal-book-detail__authors-list'>
            {authors.map(author => (
              <div className='modal-book-detail__authors-item' key={author.id}>
                {author.name}
              </div>
            ))}
          </ul>
        </div>
      )
    }
  }

  const renderItem = (item, label, formattedItem = item) => (
    item && <p><strong>{label}:</strong> {formattedItem}</p>
  )

  return (
    <div className='modal__container'>
      <Modal.Header title='Detalhes' handleCloseModal={handleCloseModal} />
      <Modal.Body>
        <div className='modal-book-detail__wrapper'>
          <div className='modal-book-detail_img'>
            <img src={book.photo.url || `${process.env.PUBLIC_URL}/img/00_Default_icon_pic.png`} alt={book.name} />
          </div>
          <div className='modal-book-detail__info__wrapper'>
            <div className='modal-book-detail__title'>
              <h1 className='title'>{name}</h1>
            </div>
            <div className='modal-book-detail__subinfo'>
              {renderItem(item.value, 'Preço', formatCurrencyToBr(item.value))}
              {
                item.favorite
                ?(<div className='modal-book-detail__favorite'>
                  <img src={favoriteSeal} alt='Este livro é um destaque' />
                  <p>Este livro é um destaque</p>
                </div>)
                : ''
              }

              {renderAuthors(book.authors)}
              {renderItem(book.isbn, 'ISBN')}
              {book.average &&
              <div className='modal-book-detail__rating'>
                <p><strong>Nota:</strong></p>
                <StarRating rating={book.average} />
              </div>
              }
              {renderItem(book.publisher.name, 'Editora')}
              {renderItem(book.description, 'Descrição')}
            </div>
          </div>
        </div>
      </Modal.Body>
    </div>
  )
}

export default ModalItem



// WEBPACK FOOTER //
// ./src/components/Modal/ModalItem/index.js